import { Grid2 as Grid, Typography } from "@mui/material";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextEditor } from "components/FormControls/TextEditor/TextEditor";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { RewardFields } from "types/rewards";
import { useStyles } from "../RewardForm.styles";

interface Props {
  index: number;
  translation: RewardFields["translations"][number];
  setFieldValue: (field: string, value: string) => void;
  isEditMode?: boolean;
}

export const NameDescription = ({
  index,
  translation,
  setFieldValue,
  isEditMode,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const translationId = isEditMode ? translation?.locale : translation?.code;

  return (
    <>
      <Grid size={12}>
        <TextInput
          data-sentry-unmask
          className={classes.fullWidth}
          label={
            index === 0 ? (
              <RequiredFieldLabel
                text={`${message({
                  id: "name",
                })} (${translation?.languageName || translation?.code || translation?.locale})`}
              />
            ) : (
              `${message({
                id: "name",
              })} (${translation?.languageName || translation?.code || translation?.locale})`
            )
          }
          name={`translations[${index}].name`}
          data-test-id={`reward-form-name-${
            isEditMode ? translation?.locale : translation?.code
          }-input`}
          width="100%"
        />
      </Grid>
      <Grid size={12}>
        <Typography className={classes.fieldName}>
          {`${message({
            id: "description",
          })} (${translation?.languageName || translation?.code || translation?.locale})`}
        </Typography>
        <TextEditor
          key={`description-${translationId}`}
          onChange={(val) =>
            setFieldValue(`translations[${index}].shortDescription`, val)
          }
          value={translation?.shortDescription}
          data-test-id={`reward-form-description-${translationId}-input`}
        />
      </Grid>
    </>
  );
};
